// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".XTc2JTM-EZdeWxHIdED6Fw\\=\\={width:24px;height:24px}.VmNinfXXzD3Y0Gj9Y1tNLA\\=\\={height:40px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-flex:0;-ms-flex:0 0 40px;flex:0 0 40px;position:relative;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}html[dir] .VmNinfXXzD3Y0Gj9Y1tNLA\\=\\={margin:16px 16px 0 16px}.XTc2JTM-EZdeWxHIdED6Fw\\=\\={color:var(--iconSecondary,#919191)}.XTc2JTM-EZdeWxHIdED6Fw\\=\\=.s6Ag6Rja0usiyZjB8rr5dQ\\=\\={color:var(--themePrimary,#0078d4)}", ""]);
// Exports
exports.locals = {
	"selectBox": "XTc2JTM-EZdeWxHIdED6Fw==",
	"container": "VmNinfXXzD3Y0Gj9Y1tNLA==",
	"isSelected": "s6Ag6Rja0usiyZjB8rr5dQ=="
};
module.exports = exports;
